let desktopSearchIcon = document.querySelector("#desktop_search_icon");
let mobileSearchIcon = document.querySelector("#mobile_search_icon");
let containerResultSearch = document.querySelector(".container_result_search");

if (containerResultSearch !== null) {
  containerResultActive(desktopSearchIcon, containerResultSearch);
  containerResultActive(mobileSearchIcon, containerResultSearch);
  document.querySelector(".block_search_input") &&
    document.querySelector(".block_search_input").classList.add("active");
  containerResultSearch && containerResultSearch.classList.add("active_search");
}

function containerResultActive(iconSearch, containerResult) {
  iconSearch &&
    iconSearch.addEventListener("click", function () {
      containerResult && containerResult.classList.toggle("active_search");
    });
}

let btnSearch = document.querySelector(".icon_input_search");

btnSearch &&
  btnSearch.addEventListener("click", function () {
    getSearchQuestion();
  });
// document.addEventListener("keydown", function (e) {
//   if (e.which === 13) {
//     getSearchQuestion();
//   }
// });
let searchInputElement = document.querySelector("#main_header_search")
searchInputElement.addEventListener("keydown", function (e) {
  if (e.which === 13) {
    getSearchQuestion();
  }
});
function getSearchQuestion() {
  let searchQuestion = document.querySelector("#main_header_search").value;
  let searchUrl = btnSearch.getAttribute("data-url");
  if (searchQuestion.trim() != "") {
    window.location.href = searchUrl + "?q=" + searchQuestion;
  }
}

if (typeof searchWorlds !== "undefined") {
  let instance = new Mark(document.querySelector(".container_result_search"));
  instance.mark(searchWorlds);
}
